export default function Sang() {
	return (
		<div className="bio">
			<h3>Sanghyun Byun</h3>
			<p>$$$$$$$$$$</p>
		</div>
	);
}